import React, { useState, useEffect } from "react";

import styled, { css } from "styled-components/macro";

import { checkMediaQueryListener } from "../../../helpers/scripts";
import {
  vars,
  colors,
  font,
  Wrapper,
  Section as section,
  SectionContent,
  SectionTitle,
  SectionText,
  SectionSubtitle,
} from "../../../helpers/styles";
import { Grid as grid, GridDataCell, Label, Value } from "../../global/Grid";

function desktopEngines(props) {
  const details = props;

  // details shorthand (e. detail('manufacturer'))
  function detail(key) {
    return details[key];
  }

  const threeEngine = detail("engine3_serial_number") || detail("engine3_total_hours");
  const oneEngine = !detail("engine2_serial_number") && !detail("engine2_total_hours");

  return (
    <SectionContent>
      <Grid gridLayout={oneEngine ? "full" : threeEngine ? "quarters" : "thirds"} noPadding>
        <IntroCell>
          <IntroGraphic>
            <Engine />
          </IntroGraphic>
          <IntroLabel>Engine 1</IntroLabel>
        </IntroCell>
        {!oneEngine ? (
          <IntroCell>
            <IntroGraphic>
              <Engine />
            </IntroGraphic>
            <IntroLabel>Engine 2</IntroLabel>
          </IntroCell>
        ) : null}

        {threeEngine ? (
          <IntroCell>
            <IntroGraphic>
              <Engine />
            </IntroGraphic>
            <IntroLabel>Engine 3</IntroLabel>
          </IntroCell>
        ) : null}

        {!oneEngine ? (
          <IntroCell>
            <IntroGraphic>
              <Apu />
            </IntroGraphic>
            <IntroLabel>APU</IntroLabel>
          </IntroCell>
        ) : null}
      </Grid>
      <Grid gridLayout={oneEngine ? "full" : threeEngine ? "quarters" : "thirds"}>
        <GridDataCell
          label="manufacturer"
          value={detail("engine_manufacturer")}
          spanCol={oneEngine ? null : threeEngine ? 3 : 2}
          noPaddingLeft
          altColor
        />
        {!oneEngine ? <GridDataCell label="manufacturer" value={detail("apu_manufacturer")} altColor /> : null}
        <GridDataCell
          label="model"
          value={detail("engine_model")}
          spanCol={oneEngine ? null : threeEngine ? 3 : 2}
          noPaddingLeft
          altColor
        />
        {!oneEngine ? <GridDataCell label="model" value={detail("apu_model")} altColor /> : null}

        <GridDataCell label="Serial Number" value={detail("engine1_serial_number")} noPaddingLeft altColor />
        {!oneEngine ? <GridDataCell label="Serial Number" value={detail("engine2_serial_number")} altColor /> : null}
        {threeEngine ? <GridDataCell label="Serial Number" value={detail("engine3_serial_number")} altColor /> : null}
        {!oneEngine ? <GridDataCell label="Serial Number" value={detail("apu_serial")} altColor /> : null}
        <GridDataCell
          label="Total Hours"
          value={detail("engine1_total_hours") ? parseInt(detail("engine1_total_hours")).toLocaleString() : null}
          noPaddingLeft
          altColor
        />
        {!oneEngine ? (
          <GridDataCell
            label="Total Hours"
            value={detail("engine2_total_hours") ? parseInt(detail("engine2_total_hours")).toLocaleString() : null}
            altColor
          />
        ) : null}
        {threeEngine ? (
          <GridDataCell
            label="Total Hours"
            value={detail("engine3_total_hours") ? parseInt(detail("engine3_total_hours")).toLocaleString() : null}
            altColor
          />
        ) : null}
        {!oneEngine ? (
          <GridDataCell
            label="Total Hours"
            value={detail("apu_total_hours") ? parseInt(detail("apu_total_hours")).toLocaleString() : null}
            altColor
          />
        ) : null}
        <GridDataCell
          label="Total Cycles"
          value={detail("engine1_cycles") ? parseInt(detail("engine1_cycles")).toLocaleString() : null}
          noPaddingLeft
          altColor
        />
        {!oneEngine ? (
          <GridDataCell
            label="Total Cycles"
            value={detail("engine2_cycles") ? parseInt(detail("engine2_cycles")).toLocaleString() : null}
            altColor
          />
        ) : null}
        {threeEngine ? (
          <GridDataCell
            label="Total Cycles"
            value={detail("engine3_cycles") ? parseInt(detail("engine3_cycles")).toLocaleString() : null}
            altColor
          />
        ) : null}
        {!oneEngine ? (
          <GridDataCell
            label="Total Cycles"
            value={detail("apu_total_cycles") ? parseInt(detail("apu_total_cycles")).toLocaleString() : null}
            altColor
          />
        ) : null}
        <GridDataCell
          label="Maintenance Programs"
          value={detail("engine_maintenance_program")}
          spanCol={oneEngine ? null : threeEngine ? 3 : 2}
          noPaddingLeft
          altColor
        />
        {!oneEngine ? (
          <GridDataCell label="Maintenance Program" value={detail("apu_maintenance_program")} altColor />
        ) : null}
      </Grid>
    </SectionContent>
  );
}

function mobileEngines(props) {
  const details = props;

  // details shorthand (e. detail('manufacturer'))
  function detail(key) {
    return details[key];
  }

  const threeEngine = detail("engine3_serial_number");
  const oneEngine = (detail("engine2_serial_number") && detail("engine2_total_hours")) === null;

  return (
    <>
      <SectionContent>
        <Grid noPadding>
          <IntroCell>
            <IntroGraphic>
              <Engine />
            </IntroGraphic>
            <IntroLabel>Engine 1</IntroLabel>
          </IntroCell>
        </Grid>
        <Grid>
          <GridDataCell label="manufacturer" value={detail("engine_manufacturer")} altColor />
          <GridDataCell label="model" value={detail("engine_model")} altColor />
          <GridDataCell
            label="Total Hours"
            value={detail("engine1_total_hours") ? parseInt(detail("engine1_total_hours")).toLocaleString() : null}
            altColor
          />
          <GridDataCell
            label="Total Cycles"
            value={detail("engine1_cycles") ? parseInt(detail("engine1_cycles")).toLocaleString() : null}
            altColor
          />
          <GridDataCell label="Serial Number" value={detail("engine1_serial_number")} altColor />
          <GridDataCell label="Maintenance Programs" value={detail("engine_maintenance_program")} altColor />
        </Grid>
      </SectionContent>
      {!oneEngine ? (
        <SectionContent>
          <Grid noPadding>
            <IntroCell>
              <IntroGraphic>
                <Engine />
              </IntroGraphic>
              <IntroLabel>Engine 2</IntroLabel>
            </IntroCell>
          </Grid>
          <Grid>
            <GridDataCell label="manufacturer" value={detail("engine_manufacturer")} altColor />
            <GridDataCell label="model" value={detail("engine_model")} altColor />
            <GridDataCell
              label="Total Hours"
              value={detail("engine2_total_hours") ? parseInt(detail("engine2_total_hours")).toLocaleString() : null}
              altColor
            />
            <GridDataCell
              label="Total Cycles"
              value={detail("engine2_cycles") ? parseInt(detail("engine2_cycles")).toLocaleString() : null}
              altColor
            />
            <GridDataCell label="Serial Number" value={detail("engine2_serial_number")} altColor />
            <GridDataCell label="Maintenance Programs" value={detail("engine_maintenance_program")} altColor />
          </Grid>
        </SectionContent>
      ) : null}
      {threeEngine ? (
        <SectionContent>
          <Grid noPadding>
            <IntroCell>
              <IntroGraphic>
                <Engine />
              </IntroGraphic>
              <IntroLabel>Engine 3</IntroLabel>
            </IntroCell>
          </Grid>
          <Grid>
            <GridDataCell label="manufacturer" value={detail("engine_manufacturer")} altColor />
            <GridDataCell label="model" value={detail("engine_model")} altColor />
            <GridDataCell
              label="Total Hours"
              value={detail("engine3_total_hours") ? parseInt(detail("engine3_total_hours")).toLocaleString() : null}
              altColor
            />
            <GridDataCell
              label="Total Cycles"
              value={detail("engine3_cycles") ? parseInt(detail("engine3_cycles")).toLocaleString() : null}
              altColor
            />
            <GridDataCell label="Serial Number" value={detail("engine3_serial_number")} altColor />
            <GridDataCell label="Maintenance Programs" value={detail("engine_maintenance_program")} altColor />
          </Grid>
        </SectionContent>
      ) : null}
      {!oneEngine ? (
        <SectionContent>
          <Grid noPadding>
            <IntroCell>
              <IntroGraphic>
                <Apu />
              </IntroGraphic>
              <IntroLabel>APU</IntroLabel>
            </IntroCell>
          </Grid>
          <Grid>
            <GridDataCell label="manufacturer" value={detail("apu_manufacturer")} altColor />
            <GridDataCell label="model" value={detail("apu_model")} altColor />
            <GridDataCell
              label="Total Hours"
              value={detail("apu_total_hours") ? parseInt(detail("apu_total_hours")).toLocaleString() : null}
              altColor
            />
            <GridDataCell
              label="Total Cycles"
              value={detail("apu_total_cycles") ? parseInt(detail("apu_total_cycles")).toLocaleString() : null}
              altColor
            />
            <GridDataCell label="Serial Number" value={detail("apu_serial")} altColor />
            <GridDataCell label="Maintenance Programs" value={detail("apu_maintenance_program")} altColor />
          </Grid>
        </SectionContent>
      ) : null}
    </>
  );
}

const PlaneAirframeEngines = (props) => {
  const mql = checkMediaQueryListener("md");
  const { details } = props;

  const [mobileResize, setMobileResize] = useState(mql.matches);

  useEffect(() => {
    function handleResize(e) {
      setMobileResize(e.matches);
    }
    mql.addListener(handleResize);

    // Unmounts
    return () => mql.removeListener(handleResize);
  }, [mql]);

  // details shorthand (e. detail('manufacturer'))
  function detail(key) {
    return details[key];
  }
  return (
    <Section altColor ref={props.airframeRef}>
      <Wrapper>
        <SectionContent>
          <SectionTitle>Airframe &amp; Engines</SectionTitle>
        </SectionContent>
        <SectionContent>
          <SectionSubtitle>Airframe</SectionSubtitle>
          <Grid gridLayout="thirds">
            <GridDataCell label="Airframe Hours" value={detail("airframe_total_time")} noPaddingLeft altColor />
            <GridDataCell label="Landings" value={detail("landings")} altColor />
            <GridDataCell label="Length" value={detail("length")} altColor />
            <GridDataCell label="Wingspan" value={detail("wingspan")} noPaddingLeft spanCol={2} altColor />
            <GridDataCell label="Height" value={detail("height")} altColor />
          </Grid>
        </SectionContent>
        {mobileResize ? desktopEngines(details) : mobileEngines(details)}
      </Wrapper>
    </Section>
  );
};

export default PlaneAirframeEngines;

export const Apu = () => (
  <svg viewBox="0 0 68 85">
    <path d="M34,9C26,9,19.56,16.21,19.56,25.1S26,41.22,34,41.22,48.44,34,48.44,25.1,42,9,34,9Z" fill="#d1d2d3" />
    <ellipse cx="34" cy="25.1" rx="13.94" ry="15.62" fill="#fff" />
    <path
      d="M34,46c-9.91,0-18-9-18-20.08S24.09,5.85,34,5.85s18,9,18,20.07S43.91,46,34,46ZM34,6.85c-9.36,0-17,8.56-17,19.07S24.64,45,34,45s17-8.56,17-19.08S43.36,6.85,34,6.85Z"
      fill="#d1d2d3"
    />
    <path
      d="M34,85C15.25,85,0,65.93,0,42.5S15.25,0,34,0,68,19.07,68,42.5,52.75,85,34,85ZM34,1C15.8,1,1,19.62,1,42.5S15.8,84,34,84,67,65.38,67,42.5,52.2,1,34,1Z"
      fill="#d1d2d3"
    />
  </svg>
);

export const Engine = () => (
  <svg viewBox="0 0 92 85.5">
    <path
      d="M34.28,50.35A26.83,26.83,0,0,1,30,46.8a15.57,15.57,0,0,0,.36-2,16.41,16.41,0,0,0,4.3.6H35c3.09,0,7.16-.45,9-2.59l-.76-.66C42,43.58,39.05,44.38,35,44.38a14.84,14.84,0,0,1-4.51-.6c0-.44,0-.89,0-1.35,0-.29,0-.57,0-.85a18.68,18.68,0,0,0,4.64-2.43c4.05-2.73,6.84-5.56,7.86-8L42,30.79c-1,2.23-3.61,4.91-7.51,7.54a18,18,0,0,1-4.17,2.22A16.43,16.43,0,0,0,30,38.6a34.75,34.75,0,0,0,4-5.26c3.27-5.09,5.35-9.46,5.86-12.33l-1-.17c-.48,2.74-2.51,7-5.71,12a35.75,35.75,0,0,1-3.45,4.66,11.17,11.17,0,0,0-.62-1.4,63,63,0,0,0,2.7-7.36c2.13-6.82,3.27-12.22,3.21-15.23l-1,0c.06,2.9-1.07,8.2-3.16,14.92A65,65,0,0,1,28.37,35a7,7,0,0,0-.73-.87c.5-2.76.89-5.55,1.13-8.33.74-7.75.81-13.55.2-16.34L28,9.7c.58,2.69.5,8.38-.23,16-.22,2.58-.57,5.16-1,7.73a3.79,3.79,0,0,0-.8-.36c-.05-2.72-.2-5.44-.47-8.13C24.94,19.48,24,12.33,22.63,9.46l-.9.44c1,2.13,2,7.52,2.74,15.17.27,2.61.41,5.25.46,7.88a1.21,1.21,0,0,0-.19,0,3.84,3.84,0,0,0-.71.11c-.51-2.29-1.11-4.56-1.82-6.79-1.51-4.84-3.7-11-5.58-12.85l-.7.71c1.33,1.31,3.27,5.85,5.33,12.44.7,2.22,1.3,4.49,1.81,6.78a10.24,10.24,0,0,0-1.18.49c-.77-1.49-1.62-2.93-2.53-4.33-2.33-3.63-5.58-8.08-7.75-8.65l-.26,1c1.44.37,4.05,3.37,7.17,8.22Q19.87,32.11,21,34.3a16.33,16.33,0,0,0-2,1.32c-.59-.47-1.2-.93-1.84-1.35-2.9-2-6.83-4.12-9-3.25l.37.93c1.38-.54,4.33.61,8.11,3.15q.82.55,1.62,1.17a11.74,11.74,0,0,0-2.93,3.82c-3,0-6.67.57-8.41,2.58l.76.65C8.86,42,11.42,41.22,15,41.1a6.78,6.78,0,0,0-.28,2,7,7,0,0,0,1,3.34C11.73,49.13,9,51.91,8,54.28l.92.39c.93-2.19,3.51-4.8,7.27-7.37a12.57,12.57,0,0,0,1.67,1.88c.24.21.48.42.73.61-.55.76-1.08,1.53-1.57,2.33-3.27,5.08-5.35,9.46-5.85,12.33l1,.17c.48-2.74,2.51-7,5.71-12,.48-.77,1-1.52,1.53-2.26a15,15,0,0,0,1.69,1c-.7,1.75-1.32,3.53-1.85,5.32C17.11,63.56,16,69,16,72l1,0C17,69.06,18.1,63.76,20.2,57c.52-1.74,1.12-3.47,1.79-5.17a11,11,0,0,0,1.15.43c-.42,2.44-.75,4.9-1,7.35-.74,7.75-.81,13.55-.2,16.34l1-.22c-.58-2.69-.5-8.38.23-16,.21-2.4.53-4.81.94-7.2a4.72,4.72,0,0,0,.81.08H25q.07,4,.46,7.88C26,66,26.93,73.13,28.32,76l.9-.43c-1-2.13-2-7.52-2.74-15.18-.27-2.63-.42-5.3-.46-8a4.34,4.34,0,0,0,.82-.38c.53,2.41,1.16,4.81,1.9,7.16,1.51,4.84,3.7,11,5.58,12.85l.7-.71C33.69,70,31.75,65.49,29.7,58.9c-.79-2.48-1.45-5-2-7.57a5.77,5.77,0,0,0,.75-.92A51.06,51.06,0,0,0,31.59,56c2.33,3.63,5.57,8.08,7.75,8.65l.26-1c-1.44-.38-4.05-3.37-7.17-8.22a50,50,0,0,1-3.35-6,11.45,11.45,0,0,0,.62-1.5,27.06,27.06,0,0,0,4,3.29c2.45,1.66,5.63,3.45,7.88,3.45a3.27,3.27,0,0,0,1.15-.19l-.37-.94C41,54.05,38.06,52.9,34.28,50.35Z"
      fill="#d1d2d3"
    />
    <path
      d="M23.3,81.93c-11.79,0-21.39-17.58-21.39-39.18S11.51,3.57,23.3,3.57,44.69,21.15,44.69,42.75,35.09,81.93,23.3,81.93Zm0-77.36C12.06,4.57,2.91,21.7,2.91,42.75S12.06,80.93,23.3,80.93,43.69,63.8,43.69,42.75,34.54,4.57,23.3,4.57Z"
      fill="#d1d2d3"
    />
    <path
      d="M25.46,85.5C11.42,85.5,0,66.32,0,42.75S11.42,0,25.46,0,51.63,19.58,51.63,42.75,39.65,85.5,25.46,85.5Zm0-84.5C12,1,1,19.73,1,42.75S12,84.5,25.46,84.5,50.63,65.38,50.63,42.75,39.1,1,25.46,1Z"
      fill="#d1d2d3"
    />
    <path
      id="Path_69"
      data-name="Path 69"
      d="M30,42.44c.1,5.15-2.08,9.48-4.86,9.66s-9.83-3.84-9.93-9,6.79-9.48,9.57-9.66S29.89,37.28,30,42.44Z"
      fill="#fff"
    />
    <path
      d="M37,85.5H25.46C11.42,85.5,0,66.32,0,42.75S11.37.09,25.35,0H36.14C73.2,0,92,13.78,92,41,92,57.59,84.85,85.5,37,85.5ZM25.36,1C11.93,1.09,1,19.82,1,42.75S12,84.5,25.46,84.5H37C71.81,84.5,91,69,91,41,91,14.44,72.54,1,36.14,1Z"
      fill="#d1d2d3"
    />
  </svg>
);

const Section = styled(section)`
  background: ${colors.mineShaft};

  ${(props) =>
    props.altColor &&
    css`
      ${SectionTitle} {
        color: ${colors.bermudaGray};
      }

      ${SectionText} {
        color: ${colors.white};
      }

      ${SectionSubtitle} {
        color: ${colors.tea};
      }

      ${Label} {
        color: ${colors.makara};
        font-weight: 800;
      }

      ${Value} {
        color: ${colors.white};
        font-weight: 200;
      }
    `}
`;

const Grid = styled(grid)`
  background: ${(props) => (props.noPadding ? "transparent" : colors.tundora)};
`;

const IntroCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  padding: ${vars.gridGap * 1.5}px;
`;

const IntroGraphic = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90px;
  width: 90px;

  svg {
    width: auto;
    height: 100%;
  }
`;

const IntroLabel = styled.p`
  ${font({
    name: "realist",
    size: "22px",
    weight: 400,
    color: colors.tea,
    letterSpacing: "1.1px",
    transform: "uppercase",
  })};
  text-align: center;
  margin: ${vars.gridGap}px 0 auto;
`;
